<script>
import { login } from '@/request/api/login'
import { mapMutations } from 'vuex';
export default {
    data() {
        return {
            checked: false,//记住密码
            loading: false,
            form: {
                username: '',
                password: '',
            },
            rules: {
                username: [
                    { required: true, message: '用户名必填', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '密码必填', trigger: 'blur' },
                ],
            }
        }
    },
    created() { },
    methods: {
        ...mapMutations({ 'vuexLogin': 'login' }),
        //
        handleSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.req()
                } else {
                    return false;
                }
            });

        },
        async req() {
            this.loading = true
            let { code, msg, data } = await login(this.form)
            this.loading = false
            if (code != 0) return this.$message.error(msg)
            const storeData = { 
                token: data.token, 
                username: data.user.username, 
                id: data.user.id,
                deptId: data.user.deptId, // 保存部门ID
                isManager: data.user.isManager // 保存管理员标识
            };
            this.vuexLogin(storeData)
            window.location.href = '/'
            this.$notify({ title: '成功', message: msg, type: 'success' });
        }
    }
}
</script>
<template>
    <!-- <div class="max-login d-flex a-center j-center flex-column">
        <div class="login">
            <div class="title">{{ $win.mconfig.name }}</div>
            <div class="login-title d-flex a-center j-center">账号登录</div>
            <div class="outInput">
                <el-form ref="form" :rules="rules" :model="form" label-width="80px">
                    <el-form-item label="用户名" prop="username">
                        <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input v-model="form.password" placeholder="请输入密码" show-password></el-input>
                    </el-form-item>
                    <div style="margin-top: 10px; margin-left: 80px;">
                        <el-checkbox v-model="checked">记住密码</el-checkbox>
                    </div>
                    <div style="margin-top: 10%;">
                        <el-button @click="handleSubmit" class="my_submit" type="primary" round :loading="loading">登录</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div> -->
    <div class="fullpage d-flex">

        <div class="login-container">
            <div class="title">
                <img src="../assets/login/login_title.png" />
            </div>
            <div class="subtitle">
                SMART TEACHING RESEARCH PLATFORM
            </div>
            <div class="login-box">
                <div class="login-form-title">账号登录</div>
                <el-form ref="form" :rules="rules" :model="form" label-width="0px" class="login-form" @keyup.enter.native="handleSubmit">
                    <el-form-item prop="username">
                        <el-input v-model="form.username" placeholder="请输入用户名" class="login-form-item"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="form.password" placeholder="请输入密码" show-password
                            class="login-form-item"></el-input>
                    </el-form-item>
                    <div style="margin-top: 10px; width: 340px; ">
                        <el-checkbox v-model="checked" style="color: #0783FA;">记住密码</el-checkbox>
                    </div>
                    <div style="margin-top: 10%;">
                        <el-button @click="handleSubmit" class="submit-button" type="primary" round
                            :loading="loading">登录</el-button>
                    </div>
                </el-form>
            </div>

        </div>

        <!-- <div class="f-r">
            <div class="login">
                <div class="login-title d-flex a-center j-center">账号登录</div>
                <div class="outInput">
                    
                </div>
            </div>
        </div> -->
    </div>
</template>

<style scoped lang="less">
/* 引入阿里巴巴普惠体字体 */
@font-face {
    font-family: 'AlibabaPuHuiTi';
    src: url('../assets/fonts/AlibabaPuHuiTi-3-55-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

/* 引入阿里巴巴普惠体粗体字体 */
@font-face {
    font-family: 'AlibabaPuHuiTi-Bold';
    src: url('../assets/fonts/AlibabaPuHuiTi-3-85-Bold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
}

.fullpage {
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: url(../assets/login/login_bg.png) no-repeat center;
    background-size: cover;

    .f-l {
        background: #555 url(../assets/imgs/auth_banner.png) no-repeat center;
        background-size: cover;
        position: relative;

        .mark {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, .5);
            z-index: 1;
        }

        .bottom {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            color: #fff;
            padding: 40px;
            background-image: linear-gradient(transparent, #000);
            z-index: 3;
        }
    }

    .login-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .title {
            width: 418px;
            height: 91px;
            display: flex;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .subtitle {
            font-family: 'AlibabaPuHuiTi', Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;
            font-weight: 400;
            font-size: 22px;
            color: rgba(255, 255, 255, 0.55);
            line-height: 22px;
            text-align: left;
            font-style: normal;
            text-transform: none;
        }

        .login-box {
            background: url(../assets/login/login_form.png) no-repeat center;
            width: 502px;
            height: 457px;
            margin-top: 76px;
            padding: 65px 80px 0 80px;
            display: flex;
            flex-direction: column;
            align-items: center;


            .login-form-title {
                font-family: 'AlibabaPuHuiTi-Bold', Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;
                // font-weight: bold;
                font-size: 24px;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                color: white;
            }

            .login-form {
                margin-top: 58px;
                width: 340px;
            }

            .login-form-item {
                border: 1px solid #0783FA !important;
                background-color: transparent !important;
                margin-top: 10px;
            }

            /deep/ .el-input__inner,
            .el-input__inner {
                background-color: transparent !important;
                border: none !important;
                color: white !important;
                box-shadow: none !important;

                &::placeholder {
                    color: #89C5FF !important;
                }

                &::-webkit-input-placeholder {
                    color: #89C5FF !important;
                }

                &::-moz-placeholder {
                    color: #89C5FF !important;
                }

                &:-ms-input-placeholder {
                    color: #89C5FF !important;
                }

                &:focus,
                &:hover {
                    background-color: transparent !important;
                    border: none !important;
                    box-shadow: none !important;
                    outline: none !important;
                }
            }

            /deep/ .el-input,
            .el-input {
                background-color: transparent !important;
                width: 100%;
                height: 100%;

                /deep/ .el-input__wrapper,
                .el-input__wrapper {
                    background-color: transparent !important;
                    box-shadow: none !important;
                    border: none !important;
                    height: 100%;
                    padding: 0 !important;
                }
            }

            /deep/ .el-input-group__append,
            .el-input-group__append {
                background-color: transparent !important;
                border: none !important;
                padding: 0 10px;
            }

            /deep/ .el-form-item,
            .el-form-item {
                background-color: transparent !important;
            }

            // 记住密码样式
            .el-checkbox__label {
                color: #0783FA !important;
            }

            /deep/ .el-checkbox,
            /deep/ .el-checkbox__wrapper {
                background-color: transparent !important;
            }

            /deep/ .el-checkbox__inner,
            /deep/ .el-checkbox__input .el-checkbox__inner {
                border-color: #0783FA !important;
                background-color: transparent !important;
                background-image: none !important;
                border-width: 1px !important;
                border-style: solid !important;
                box-shadow: none !important;
            }

            /deep/ .el-checkbox__input:hover .el-checkbox__inner {
                background-color: transparent !important;
                border-color: #0783FA !important;
            }

            /deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
                background-color: transparent !important;
                border-color: #0783FA !important;
                box-shadow: none !important;
            }

            /deep/ .el-checkbox__inner {
                background-color: transparent !important;
                background-image: none !important;
                border-color: #0783FA !important;
                box-shadow: none !important;
            }

            .login-form /deep/ .el-checkbox__inner {
                background-color: transparent !important;
                background-image: none !important;
                border-color: #0783FA !important;
            }

            /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #0783FA !important;
                border-color: #0783FA !important;
            }

            /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
                background-color: #0783FA !important;
                border-color: #0783FA !important;
            }

            /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #0783FA !important;
                border-color: #0783FA !important;
            }

            /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
                background-color: #0783FA !important;
                border-color: #0783FA !important;
            }

            .submit-button {
                width: 340px;
                height: 40px;
                background: #0783FA;
                color: white;
                border-radius: 4px;
            }
        }
    }
}

/deep/ .el-input__inner:-webkit-autofill{
    transition: all 5000s ease-in-out 0s;
}

.hidden {
    display: block;
}

@media screen and(max-width:1100px) {
    .hidden {
        display: none;
    }
}
</style>